import styled from "styled-components";

export const Container = styled.div`
  padding: 32px 20px;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  h1 {
    color: #111;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.72px;
    margin-bottom: 32px;
  }
`;
